import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import StructuredData from '@/components/feature/StructuredData';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import { Link } from 'react-router-dom';

export default function Home() {
  const canonicalUrl = typeof window !== 'undefined' ? window.location.origin : '';

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="SM专业指南·全面解析SM的含义与应用"
        description="本页深度解析SM的核心概念、类型分类、安全准则与实践要点，帮助对SM感兴趣的用户全面了解SM的知识体系，建立正确认知，安全负责地探索SM相关内容。"
        keywords="SM,SM是什么,SM含义解析,SM安全准则,SM知识指南,SM类型分类,SM入门教程"
        canonicalUrl={canonicalUrl}
      />
      <StructuredData
        type="WebSite"
        data={{
          name: 'SM专业指南',
          url: canonicalUrl,
          description: 'SM专业指南，全面解析SM的核心概念、类型分类、安全准则与实践要点',
          inLanguage: 'zh-CN',
          potentialAction: {
            '@type': 'SearchAction',
            target: `${canonicalUrl}/search?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <StructuredData
        type="Organization"
        data={{
          name: 'SM专业指南',
          url: canonicalUrl,
          description: '致力于提供专业、安全、负责任的SM知识科普',
          logo: `${canonicalUrl}/logo.png`,
        }}
      />
      <StructuredData
        type="WebPage"
        data={{
          name: 'SM专业指南 - 首页',
          description: 'SM专业指南首页，全面解析SM知识体系',
          url: canonicalUrl,
          isPartOf: { '@id': `${canonicalUrl}/#website` },
        }}
      />
      <StructuredData
        type="FAQPage"
        data={{
          mainEntity: [
            {
              '@type': 'Question',
              name: 'SM的准确定义是什么？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'SM是BDSM文化中的重要组成部分，涵盖施虐（Sadism）与受虐（Masochism）两个核心维度。它指的是在双方自愿、知情同意的前提下，通过权力交换、感官刺激等方式进行的亲密互动实践。',
              },
            },
            {
              '@type': 'Question',
              name: '参与SM实践需要遵循哪些基本原则？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '所有SM实践都应遵循SSC原则（安全Safe、理智Sane、知情同意Consensual）或RACK原则（风险知情共识性癖Risk-Aware Consensual Kink）。',
              },
            },
            {
              '@type': 'Question',
              name: '如何与伴侣讨论SM相关的兴趣？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '建议选择一个私密、放松的环境，以非评判性的方式表达自己的兴趣和感受。可以先分享相关的文章或书籍作为切入点。',
              },
            },
            {
              '@type': 'Question',
              name: 'SM实践有哪些常见的安全注意事项？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '安全注意事项包括：提前学习人体解剖学知识、准备安全剪等应急工具、确保束缚不会阻碍血液循环或呼吸、避免在酒精或药物影响下进行实践。',
              },
            },
            {
              '@type': 'Question',
              name: 'SM与心理健康的关系是怎样的？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '在安全、自愿、知情同意的框架下进行的SM实践，对于参与者可能具有压力释放、自我探索和亲密关系深化的积极意义。但SM并非心理治疗的替代方式。',
              },
            },
            {
              '@type': 'Question',
              name: '如何判断自己是否适合参与SM实践？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '适合参与SM实践的人通常具备：清晰的自我认知和边界意识、良好的情绪调节能力、愿意花时间学习和准备、能够与伴侣建立信任关系。',
              },
            },
          ],
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />

        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              安全、专业、负责任
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
              我们坚信，只有在充分了解、真诚沟通和严格遵守安全准则的前提下，SM探索才是有意义的。我们的每一篇文章都经过仔细审核，确保信息的准确性和安全性。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 rounded-lg font-medium text-sm whitespace-nowrap hover:bg-secondary-600 transition-colors cursor-pointer"
            >
              了解更多关于我们
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>

        <FAQSection />

        <section className="py-16 md:py-20 px-4 md:px-6 bg-accent-500">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4">
              准备好开始探索了吗？
            </h2>
            <p className="text-background-50/80 text-sm md:text-base mb-8 leading-relaxed">
              从基础概念开始，循序渐进地建立您的SM知识体系。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/sm-basics"
                className="px-8 py-3.5 bg-background-50 text-foreground-950 rounded-lg font-medium text-base whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
              >
                浏览知识库
              </Link>
              <Link
                to="/category/safety-guidelines"
                className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg font-medium text-base whitespace-nowrap hover:bg-background-50/25 transition-colors cursor-pointer"
              >
                安全准则优先
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}